

export const translateService = {
    translate
};


async function fetcher(url, requestOptions) {

    return fetch(url, requestOptions)
        .then(async function (response) {
            if (response.ok) {
                let text = await response.text();
                const data = text && JSON.parse(text);
                return data;
            } else {
                if (response.status === 401) {

                    // auto logout if 401 response returned from api
                    //userService.logout();
                    let text = await response.text();
                    const data = text && JSON.parse(text);
                    return data;

                } else if (response.status === 400 || response.status === 500) {
                    let text = await response.text();
                    const data = text && JSON.parse(text);
                    return data;
                } else {
                    let text = await response.text();
                    let data = null;
                    if (text) {
                        data = text && JSON.parse(text);
                    }
                    const error = (data && data.message) || response.statusText;
                    return null;
                    //return Promise.reject(error);
                }
            }
        })

        .catch(error => {
            console.log(error);
            return Promise.reject(error);
        })


}

function translate(to_Language, text) {

    try {


        return true;
    } catch (err) {
        console.log(err);
        return false
    }
}
